import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { pushClientError } from "./utils/clientErrorBuffer";
import { installChunkLoadRecovery } from "./lib/app/chunkLoadRecovery";

// FLOYD 2026-10-26 (DEFECT 1): a page running a superseded build learns it the first time a lazy chunk of that
// build is gone, and says so (AppUpdateRequiredBanner) instead of leaving every later action to fail one by one.
// Installed before the first render so no early failure is missed.
if (typeof window !== "undefined") {
  installChunkLoadRecovery(window);
}

// FIX-R35-CRIT-2: Global error relays. Without these, async errors that
// escape React's rendering path (setTimeout callbacks, unhandled promise
// rejections, errors in realtime handlers) vanish into the browser console
// and never reach support. These handlers write into the sessionStorage
// client-error buffer so the next bug report includes them automatically.
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    try {
      pushClientError({
        source: "window-error",
        message: event.message || "Uncaught error",
        stack: event.error?.stack,
        route: window.location.pathname + window.location.search,
        extra: {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        },
      });
    } catch {
      // never throw from an error listener
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    try {
      const reason: any = event.reason;
      pushClientError({
        source: "unhandled-rejection",
        message:
          (reason && (reason.message || (typeof reason === "string" ? reason : JSON.stringify(reason)))) ||
          "Unhandled promise rejection",
        stack: reason?.stack,
        route: window.location.pathname + window.location.search,
      });
    } catch {
      // never throw
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
